import { render, staticRenderFns } from "./AddNewTag.vue?vue&type=template&id=1bf72c96&scoped=true&"
import script from "./AddNewTag.vue?vue&type=script&lang=js&"
export * from "./AddNewTag.vue?vue&type=script&lang=js&"
import style0 from "./AddNewTag.vue?vue&type=style&index=0&id=1bf72c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf72c96",
  null
  
)

export default component.exports